import React from 'react'
import { view } from 'react-easy-state'
import { Icon } from 'antd'

import VideoPlayer from 'components/common/VideoPlayer'
import DocumentRender from 'components/common/DocumentRender'

const ePub = window.ePub
class EvaluationView extends React.Component {

  loadEpub() {
    const { paper } = this.props
    if (paper.paper_type !== "epub") return
    console.log('loadEpub: paper:', JSON.parse(JSON.stringify(paper)))

    const url = this.props.paper.url
    if (!url) return

    const book = ePub(url)
    const rendition = book.renderTo("viewer", {
      manager: "continuous",
      flow: "scrolled",
      width: "100%",
      height: "1500px"
    })
    const displayed = rendition.display()
    console.log("displayed:", displayed)
  }

  componentDidMount() {
    this.loadEpub()
  }

  render() {

    const { paper, paperAttempt } = this.props

    const videoPlayerOptions = {
      autoplay: false,
      controls: [
        'play-large',
        'play',
        'progress',
        'duration',
        'volume',
        'settings',
        'pip',        
        'fullscreen',
      ],
      playsinline: true,
      html5: {
        hlsjsConfig: {
          debug: true
        }
      },
      sources: [{
        src: paperAttempt.evaluation_video_url,
        type: 'application/vnd.apple.mpegURL',
        overrideNative: true,
      }]
    }

    let document
    let asnwerSheet

    if(true) {
      document = {
        url: paperAttempt.evaluation_pdf_url,
        type: 'pdf'
      }
    }

    if(true) {
      asnwerSheet = {
        url: paper.answer_sheet_pdf_url,
        type: 'pdf'
      }
    }

    return (
      <div className="lecture-video-view">
        <div className="header"><Icon type="youtube" /> <h2>{paper.name}</h2></div>
        <div className="lecture-video-content" style={{ padding: '30px 0px' }}>
          <div data-vjs-player>
            <VideoPlayer {...videoPlayerOptions} />
          </div>
          {document && <DocumentRender document={document} style={{ marginTop: 50 }} title="Checked Copy"/>}
          {asnwerSheet && <DocumentRender document={asnwerSheet} style={{ marginTop: 50 }} title="Answer Sheet"/>}
        </div>
      </div>
    )
  }
}

export default view(EvaluationView)
